module.exports = __webpack_public_path__ + "static/FAQ-5ec9f48a6397f7fa9cfab6a411d1fd09.png";